import { render, staticRenderFns } from "./configForm.vue?vue&type=template&id=06ceffae&scoped=true"
import script from "./configForm.vue?vue&type=script&lang=js"
export * from "./configForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ceffae",
  null
  
)

export default component.exports